import { CustomerUsersAutocompleteResponse } from "../../../../../features/customer/types/queries";

export type CustomerUserAutocompleteOption = {
  id: string;
  name: string;
  customerCompanyName: string;
};

export const formatCustomerUserName = (firstName: string, lastName: string) =>
  `${firstName} ${lastName}`.trim();

export const formatCustomerUserOptionLabel = (
  name: string,
  companyName?: string,
) => (companyName ? `${name}, ${companyName}` : name);

export const mapCustomerUserToOption = (
  user: Pick<
    CustomerUsersAutocompleteResponse,
    "id" | "firstName" | "lastName" | "customerCompanyName"
  >,
): CustomerUserAutocompleteOption => ({
  id: user.id,
  name: formatCustomerUserName(user.firstName, user.lastName),
  customerCompanyName: user.customerCompanyName ?? "",
});
